// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__TnVKZ","header__content":"styles_header__content__XKZ93"};